module.exports = __webpack_public_path__ + "static/media/delta-lake.0ab64640.svg";